import { PushToTracker  } from "../../utils/tracking";

// data contains - { link, page }
export const activationPendingPopup = ( data ) => {
    try{
        PushToTracker(
                { "gtm":false, "segment": true},
                { "segment": {"event":'Activation Pending Pop-up Displayed', "payload":{...data}}})
    }catch{
        console.log('error while pushing to datalayer')
    }
}

// data contains - { step, osid, source }
export const raiseServiceRequestPressed = ( data ) => {
    try{
        PushToTracker(
                { "gtm":false, "segment": true},
                { "segment": {"event":'Raise Service Request Pressed', "payload": {...data}}})
    }catch{
        console.log('error while pushing to datalayer')
    }
}
